import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { ClaimStatusReportType, ReportsFilterType } from 'src/app/common/enum/reports-filter-type';
import { CoreHttpService } from 'src/app/providers/core-http/core-http.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})

export class ReportService extends CoreHttpService {
  public todate = new Date();
  private reportUrl: string = `${environment.apiUrl}/Reports`;
  private commonUrl: string = `${environment.apiUrl}/Common`;
  private cereusReportUrl: string = `${environment.apiUrl}/CereusReports`;
  private billingRequestUrl: string = `${environment.apiUrl}/BillingRequest`;

  constructor(
    private _http: HttpClient,
    router: Router,
    spinner: NgxSpinnerService
  ) {
    super(_http, router, spinner);
  }
  public disabledDates = (date: Date): boolean => {
    date.setDate(date.getDate());
    console.log(this.todate.toString());
    return date > this.todate;
  }
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
  };
  getClaimsBilledReport(params): Observable<any> {
    return this.post(`${this.reportUrl}/GetClaimsBilledReport`, params);
  }
  getPaymentSummaryReport(params) {
    return this.post(`${this.reportUrl}/GetPaymentSummaryReport`, params);
  }
  getPaymentDetailReport(params) {
    return this.post(`${this.reportUrl}/GetPaymentDetailsReport`, params);
  }
  getAgingReport(params: any) {
    return this.post(`${this.reportUrl}/GetAgingReport`, params);
  }
  getAgingSummaryReport(params: any) {
    return this.post(`${this.reportUrl}/GetAgingSummaryReport`, params);
  }
  getFacilityForFilter(params): Observable<any> {
    return this.postParams(`${this.commonUrl}/GetFacilityMasterByID`, "", params);
  }
  getReportFacilityListByUser(params: any): Observable<any> {
    return this.postParams(`${this.commonUrl}/GetFacilitiesByUser`, params);
  }
  getURDailyReport(params: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetFacility_URDailyReport`, params);
  }
  getURReviewReport(params: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetFacility_URReviewReport`, params);
  }
  getActivitySummaryByMonth(params: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetActivitySummaryByMonth`, params);
  }
  getTotalBalanceByPayerPriority(params: any): Observable<any> {
    return this.post(`${this.reportUrl}/getTotalBalanceByPayerPriority`, params);
  }
  getPatientBalanceReport(params: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetPatientBalanceReport`, params);
  }

  //Report Filter API's
  getOverviewReportFilterData(params: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/overview-filter-data`, params);
  }

  getAuthReportFilterData(params: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/auth-filter-data`, params);
  }

  getNegotiationFilterData(params: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/negotiation-filter-data`, params);
  }

  getChargesBilledFilterData(params: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/chargesbilled-filter-data`, params);
  }

  getPaymentsFilterData(params: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/payments-filter-data`, params);
  }

  getArReportsFilterData(params: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/arreport-filter-data`, params);
  }

  getArWaterfallReportsFilterData(params: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/arwaterfall-filter-data`, params);
  }

  getReportFiltersData(filterDropdownListRequestModel: any): Observable<any> {
    return this.post(`${this.commonUrl}/GetReportFiltersData`, filterDropdownListRequestModel);
  }
  //Report Filter API's End


  getAuthReviewReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/auth-review-report`, model);
  }


  /****************************************************  REPORTING SERVICE  *********************************************/
  getOverviewReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/overview-report`, model);
  }

  getOverviewSubReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/overview-sub-report`, model);
  }

  getChargesBilledDataSource(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/chargedbilled-datasource-report`, model);
  }

  getChargesBilledSummaryReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/chargedbilled-summary-report`, model);
  }

  getChargesBilledDetailReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/chargedbilled-details-report`, model);
  }

  getChargesBilledYearlyTrendReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/chargedbilled-yearlytrend-report`, model);
  }

  getChargesBilledPendingClaimsReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/chargedbilled-pendingclaims-report`, model);
  }

  getPaymentYearlyTrendReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/payment-yearlytrend-report`, model);
  }

  getTpnNegotiationsReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/tpn-negotiation-report`, model);
  }

  getTpnReconsiderationReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/tpn-reconsideration-report`, model);
  }

  getPaymentSummaryReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/payment-summary-report`, model);
  }

  getPaymentDatasourceReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/payment-datasource-report`, model);
  }

  getPaymentDetailsReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/payment-details-report`, model);
  }

  getArOpenChargesReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/ar-opencharges-report`, model);
  }

  getArPatientBalanceReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/ar-patientbalance-report`, model);
  }

  getArPayeBreakdownReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/ar-payerbreakdown-report`, model);
  }

  getArWaterfallReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/ar-payer-waterfall`, model);
  }

  getClaimStatusOverviewReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/claimstatus-overview-report`, model);
  }

  getClaimStatusPendingReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/claimstatus-pending-report`, model);
  }

  getClaimStatusInProgressReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/claimstatus-inprogress-report`, model);
  }

  getClaimStatusMrEscalationReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/claimstatus-mrescalation-report`, model);
  }

  //#region Executive Reports
  getPolicyLookupReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/policylookup-report`, model);
  }

  getChargesProjectedReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/charges-projected-report`, model);
  }

  getMonthlyProjectionReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/monthly-projection-report`, model);
  }

  getCensusProjectedReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/census-projected-report`, model);
  }

  addUpdateSchedulerSetting(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/AddUpdateSchedulerSetting`, model);
  }

  getSchedulerSettingForGrid(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/GetSchedulerSettingForGrid`, model);
  }

  //#endregion

  getPatientCaseViewDetailsByName(patientName: any = 0) {
    return this.post(`${this.cereusReportUrl}/GetPatientCaseViewDetailsByName?patientName=${patientName}`, "");
  }

  getAllPatientForDropdown() {
    return this.get(`${this.cereusReportUrl}/GetAllPatientForDropdown`);
  }

  getDefaultDateByReportId(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/report-default-filter`, model);
  }

  getCensusReportData(model: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/billing-census-report`, model);
  }

  getCensusFacilityData(): Observable<any> {
    return this.post(`${this.cereusReportUrl}/census-facility`, {});
  }

  getBillingRequestList(model: any): Observable<any> {
    return this.post(`${this.billingRequestUrl}/get-billing-requests`, model);
  }

  updateBillingRequestStatusById(model: any): Observable<any> {
    return this.post(`${this.billingRequestUrl}/update-billing-status`, model);
  }

  deleteBillingRequest(model: any): Observable<any> {
    return this.post(`${this.billingRequestUrl}/del-billing-request`, model);
  }

  deleteSelectedBillingRequest(model: any): Observable<any> {
    return this.post(`${this.billingRequestUrl}/del-selected-billing-request`, model);
  }

  addUpdateBillingRequest(model: any): Observable<any> {
    return this.post(`${this.billingRequestUrl}/addupdate-billing-request`, model);
  }

  addBillingRequestNotes(model: any): Observable<any> {
    return this.post(`${this.billingRequestUrl}/add-billing-notes`, model);
  }

  assignUserToBillingRequest(model: any): Observable<any> {
    return this.post(`${this.billingRequestUrl}/assign-billerto-requests`, model);
  }

  getBillingNotesById(model: any): Observable<any> {
    return this.post(`${this.billingRequestUrl}/get-billing-notesbyid`, model);
  }

  getAllFacilityForDropdown(): Observable<any> {
    return this.get(`${this.billingRequestUrl}/get-facility-master`);
  }

  getAllCarrierForDropdown(): Observable<any> {
    return this.get(`${this.billingRequestUrl}/get-carrier-master`);
  }

  getAllLOCForDropdown(): Observable<any> {
    return this.get(`${this.billingRequestUrl}/get-loc-master`);
  }

  getAllBillerUserForDropdown(): Observable<any> {
    return this.get(`${this.billingRequestUrl}/get-billing-user-master`);
  }

  uploadExcelData(model: any): Observable<any> {
    return this.post(`${this.billingRequestUrl}/upload-excel-data`, model);
  }
}
